export default "__VITE_ASSET__Cjmq$ztj__"